import { identify } from "./identify";
import { init } from "./init";
import { load } from "./load";
import { page } from "./page";
import { reset } from "./reset";
import { restore } from "./restore";
import { save } from "./save";
import { track } from "./track";
import {
  Analytics,
  IdentifyOptions,
  LoadOptions,
  PageOptions,
  Session,
  TrackOptions,
} from "./types";
export { EventType, Page, Section, TurnstileEvents, UnifiedAuthEvents } from "./constants";
export type { Analytics, IdentifyOptions, LoadOptions, Session, TrackOptions } from "./types";

/**
 * This is the main analytics object that will be used to track events and identify users.
 */
export const analytics: Analytics = {
  init,
  identify,
  track,
  load,
  reset,
  page,
  save,
  restore,
};

/**
 * NoopAnalytics is a no-operation implementation of the Analytics interface.
 */
export const NoopAnalytics: Analytics = {
  init: (): void => {},
  identify: (identity: IdentifyOptions): Promise<void> => {
    return Promise.resolve();
  },
  track: (data: TrackOptions): Promise<void> => {
    return Promise.resolve();
  },
  load: (opts: LoadOptions): void => {
    return;
  },
  reset: (): void => {},
  page: (opts: PageOptions = {}): void => {
    return;
  },
  save: async (): Promise<Session> => {
    return {} as Session;
  },
  restore: (sess: Session): void => {
    // No operation for restoring app state in NoopAnalytics
  },
};
